// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mov-style[data-v-260bba18]{width:100%;height:100%}.mov-style img[data-v-260bba18]{max-width:100%;max-height:100%}.test-video[data-v-260bba18]{width:100%;height:100%;object-fit:contain;mix-blend-mode:screen}", ""]);
// Exports
module.exports = exports;
